module.exports = __webpack_public_path__ + "img/adhka-yx1zn.006.e8f691ea.jpeg";